import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { t } from 'ttag'
import { interweave } from 'helpers'
import styles from './Competencies.module.scss'
import introStyles from '../IntroPage/IntroPage.module.scss'
import reportStyles from '../../Report.module.scss'
import { TraitsMatch } from 'components/common/TraitsMatch/TraitsMatch'
import next from 'assets/icons/next.svg'
import { RadarChart } from 'components/common/RadarChart/RadarChart'
import html2canvas from 'html2canvas'

const Competency = ({
  trait,
  traitScores,
  explanation,
  scoreLabel,
  language,
}) => {
  return (
    <Box className={styles.container} direction="column">
      <div className={styles.header}>
        <div className={styles.title}>{trait.label}</div>
        <div className={styles.chip}>
          <div className={styles.chipLabel}>{t`match`}:</div>
          <div className={styles.chipScore}>{scoreLabel}</div>
          <div className={styles.chipGraph}>
            <div className={cx(styles.low, styles.selected)} />
            <div
              className={cx(styles.medium, {
                [styles.selected]: trait.score > 1,
              })}
            />
            <div
              className={cx(styles.high, {
                [styles.selected]: trait.score > 2,
              })}
            />
          </div>
        </div>
      </div>
      {explanation.map((exp, index) => (
        <div key={index} className={styles.paragraph}>
          {exp
            .replace(new RegExp(t`a candidate`, 'gi'), t`someone`)
            .replace(new RegExp(t`the candidate`, 'gi'), t`someone`)}
        </div>
      ))}
      <TraitsMatch single data={traitScores} language={language} />
    </Box>
  )
}

export const Competencies = ({
  data,
  radarData,
  getTraitScores,
  explanations,
  getScoreLabel,
  language,
}) => {
  const [chartImage, setChartImage] = React.useState(null)

  const pages = data.reduce((acc, item, index) => {
    acc[Math.floor(index / 2)][index % 2] = { ...item, index }

    return acc
  }, [...Array(Math.ceil(data.length / 2)).keys()].map(_ => []))

  React.useEffect(() => {
    const captureChart = async () => {
      const chartElement = document.getElementById('chart-container')
      if (!chartElement) return

      const canvas = await html2canvas(chartElement)
      setChartImage(canvas.toDataURL('image/png'))
    }

    setTimeout(captureChart, 1000) // Ensure Recharts has rendered
  }, [])

  return pages.map((page, index) => {
    return (
      <Box
        className={reportStyles.containerWhite}
        direction="column"
        id="report"
        data-testid="report"
      >
        {index ? null : (
          <div className={cx(introStyles.header, introStyles.headerPadding)}>
            <div className={introStyles.name}>{t`Profile match`}</div>
            <div className={introStyles.position}>
              {t`Estimated match for each competency`}
            </div>
          </div>
        )}
        {!index && data.length > 2 ? (
          <div
            id="chart-container"
            style={{
              display: chartImage ? 'none' : 'block',
              width: '550px',
              height: '300px',
            }}
          >
            <RadarChart data={radarData} single maxHeight={'15rem'} />
          </div>
        ) : null}
        {chartImage && !index && (
          <img id="chart-image" src={chartImage} alt="Chart Snapshot" />
        )}
        {interweave(
          page.map(item => {
            const { index, ...competency } = item

            console.log('getTraitScores(index)', getTraitScores(index))

            return (
              <Competency
                trait={competency}
                traitScores={getTraitScores(index)}
                explanation={explanations[index]}
                scoreLabel={getScoreLabel(index)}
                language={language}
              />
            )
          }),
          <div className={styles.divider} />,
        )}
        <div className={reportStyles.next}>
          <img src={next} alt="next" />
        </div>
      </Box>
    )
  })
}
